import Router, { useRouter as useNextRouter } from 'next/router';
import { useCallback, useEffect, useState } from 'react';
import { DeepPartial, Json } from '../types/index';
import { DefaultQueryType } from '../types/query';


export function flatten<Type = Record<string, string | string[]>>(obj: Json, prefix = ''): Type {
  if (!obj) return {} as Type

  return Object.keys(obj).reduce((acc, k) => {
    const pre = prefix.length ? prefix + '.' : '';
    if (obj[k] === undefined || obj[k] === null) return acc
    if (typeof obj[k] === 'object') Object.assign(acc, flatten(obj[k] as any, pre + k));
    else acc[pre + k] = obj[k];
    return acc;
  }, {} as Type);
}

export function unflatten<Type = Json>(obj: Record<string, string | string[]>): Type {
  const simpleObj = Object.keys(obj).reduce((acc, k) => {
    acc[k] = Array.isArray(obj[k]) && obj[k].length === 1 ? obj[k][0] : obj[k];
    return acc
  }, {})
  var result = {}
  for (var i in simpleObj) {
    var keys = i.split('.')
    keys.reduce(function (r, e, j) {
      return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 == j ? obj[i] : {}) : [])
    }, result as Json)
  }
  return result as any
}

export function useOurRouter<QueryType extends DefaultQueryType>() {
  const router = useNextRouter();
  const [query, _setQuery] = useState(() => unflatten<DeepPartial<QueryType>>(router.query));

  const setQuery = useCallback(
    (values: DeepPartial<QueryType>) => {
      const url = `${window.location.pathname}?${new URLSearchParams(flatten(values as any))}`;
      router.replace(url, url, { shallow: true });
      _setQuery(values);
    },
    [router],
  );

  useEffect(() => {
    const routeChangeComplete = () => {
      _setQuery(unflatten(Router.query as any));
    };
    Router.events.on('routeChangeComplete', routeChangeComplete);
    return () => {
      Router.events.off('routeChangeComplete', routeChangeComplete);
    };
  }, []);

  return {
    ...router,
    query: query,
    push: (url: string | { pathname?: string, query?: DeepPartial<QueryType> }, as?: string, options?: {}) => {
      const _query = typeof url !== 'string' ? flatten<DeepPartial<QueryType>>(url.query as any) : {};

      if (typeof url !== 'string' && !url.pathname) {
        return setQuery(_query as any)
      }

      return router.push(typeof url === 'string' ? url : {
        pathname: url.pathname,
        query: _query
      }, as, options)
    },
    replace: (url: string | { pathname?: string, query?: DeepPartial<QueryType> }, as?: string, options?: {}) => {

      const _query = typeof url !== 'string' ? flatten<DeepPartial<QueryType>>(url.query as any) : {};

      if (typeof url !== 'string' && !url.pathname) {
        return setQuery(_query as any)
      }

      return router.replace(typeof url === 'string' ? url : {
        pathname: url.pathname,
        query: _query
      }, as, options)
    }
  }
}